import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { PartnerTerms } from 'components';
import { LoggedOutLayout } from 'containers';
import * as styles from 'components/TermsAndConditions/Terms.scss';
import { connect } from 'react-redux';
import { fetchOrganizationHostedPrivacyPolicy } from 'redux/modules/organization';
import marked from 'marked';
var PartnerTermsAndConditions = (_dec = connect(function (state) {}, {
  fetchOrganizationHostedPrivacyPolicy: fetchOrganizationHostedPrivacyPolicy
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(PartnerTermsAndConditions, _Component);

  var _super = _createSuper(PartnerTermsAndConditions);

  function PartnerTermsAndConditions(props) {
    var _this;

    _classCallCheck(this, PartnerTermsAndConditions);

    _this = _super.call(this, props);
    _this.state = {
      policy: ''
    };
    return _this;
  }

  _createClass(PartnerTermsAndConditions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.props.fetchOrganizationHostedPrivacyPolicy(this.props.params.organizationId).then(function (response) {
        _this2.setState({
          policy: response.data
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(LoggedOutLayout, {
        showNavBar: true
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement("span", {
        className: "termsWrap",
        dangerouslySetInnerHTML: {
          __html: marked(this.state.policy)
        }
      })));
    }
  }]);

  return PartnerTermsAndConditions;
}(Component)) || _class);
export { PartnerTermsAndConditions as default };